import type { ApiVehicleAvailability } from '#api/model/types.ts';
import type { VehicleAvailability } from '#domain/VehicleAvailability.ts';

export const mapVehicleAvailability = (vehicle: ApiVehicleAvailability): VehicleAvailability => ({
    vehicleId: vehicle.vehicle_id,
    searchName: vehicle.search_name,
    plate: vehicle.plate,
    tours: vehicle.tours.map(tour => ({
        id: tour.tour_id,
        name: tour.tour_name,
        status: tour.status,
        start: tour.start,
        end: tour.end,
    })),
});
